class Home {
	constructor() {
		this._init();
	}

	_init() {


		// Global theme Object from theme.js
		const _theme = window.theme;
		let $class = this;

		/*// Add FeaturedCollection (new arrivals) to global theme object
		_theme.FeaturedCollection = new function () {

			this.onSectionLoad = function (target) {

				var $container = $(target);
				//find all forms and attach Ajax request
				var $productForms = $container.find('.js-product-form');
				$productForms.each(function (){
					_theme.applyAjaxToProductForm($(this));
				})
			};

			this.onSectionUnload = function (target) {
				console.log("featured-collection unload");
			};
		}();

		// Must have call these two functions!!
		_theme.Sections.init();
		_theme.Sections.register('featured-collection', _theme.FeaturedCollection);*/
	}
}

export default Home
